import { AuthState, isResendActivationState } from "./authState";
import { any, nothing, Updater, wait, Widget } from 'widgets-for-react';
import { Api, resend_account_activation, } from "./api_to_state"
import { resend_activation_button, resend_activation_success } from "./resend_activate_account_form";
import { options } from "./utils";

export function resendActivateAccount(
  options: options,
  api: Api,
  email: string,
  s0: AuthState,
  originPath: string,
  altHeader?: string,  
) : Widget<Updater<AuthState>> {
    if (s0.status == 'logged out' && isResendActivationState(s0)) {
      return any<Updater<AuthState>>([
        s0.resendActivationState == "resend activation" ||
        s0.resendActivationState == "resend activation - error too many attempts" ?
          resend_activation_button(options, email, false, altHeader) :
        s0.resendActivationState == "resend activation - success" ?
          resend_activation_success(options, email) :
        s0.resendActivationState == "resend activation - api error" ?
          any<Updater<AuthState>>([
            wait(500, { key: "login-widget-resend-activation-promise" })(() => (s : AuthState) : AuthState => isResendActivationState(s) && s.resendActivationState != "resend activation - api error" ? s : ({...s, resendActivationState: "resend activation - resending"})),
            resend_activation_button(options, email, true, altHeader)
          ]) :
        s0.resendActivationState == "resend activation - resending" ?
          any<Updater<AuthState>>([
            resend_account_activation(api, { email }, originPath),
            resend_activation_button(options, email, true, altHeader)
          ]) : nothing()
      ])
    } else {
      return nothing()
    }  
}
